// 产品介绍
<template>
  <div class="cpjs width1200">
    <div class="cpjs-desc">
      <p>
        多贝云动态转发HTTP隧道区别于传统的提取类HTTP代理产品，用户只需全局设置一次代理服务器地址和端口等信息，后续无需再频繁设置代理服务器地址
      </p>
      <p>
        请求到达HTTP隧道接入服务器群组之后会按照账号的套餐属性动态分配到随机的边缘IP节点出口，再从最终的出口IP节点访问目标网站
      </p>
      <p>
        平台端会维护多组分布在全国各地的分布式动态IP边缘节点，这些边缘节点即构成了动态IP池，池中的IP会持续性的动态更新多贝云动态转发http隧道区别于传统的提取类HTTP代理产品，用户只需全局设置一次代理服务器地址和端口等信息，后续无需再频繁设置代理服务器地址
      </p>
    </div>
    <img
      :src="require('@/assets/images/cpjs1.png')"
      alt=""
      class="cpjs-imgs w-100"
    />
    <div class="cpjs-list">
      <p class="title">多贝云动态http产品特性</p>
      <div class="cpjs-list-content d-flex d-flex-jc-sb d-flex-fw-w">
        <div class="item" v-for="(item, index) in cpjsList" :key="index">
          <img :src="item.icon" alt="" class="img1" />
          <img :src="item.icon_active" alt="" class="img2" />
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cpjsList: [
        {
          icon: require("@/assets/images/cpjs2.png"),
          icon_active: require("@/assets/images/cpjs8.png"),
          desc: "直接从运营商采购ADSL宽带线路资源，稳定性和安全性都有保障",
        },
        {
          icon: require("@/assets/images/cpjs3.png"),
          icon_active: require("@/assets/images/cpjs9.png"),
          desc: "从底层网络节点到上层代理节点均为自主研发和部署，绝不是从网上采集或者从同行采购的，IP的稳定性、速度和质量均有保障",
        },
        {
          icon: require("@/assets/images/cpjs4.png"),
          icon_active: require("@/assets/images/cpjs10.png"),
          desc: "无需频繁修改代理IP便可轻松切换出口IP，毫秒级切换，效率极高",
        },
        {
          icon: require("@/assets/images/cpjs5.png"),
          icon_active: require("@/assets/images/cpjs11.png"),
          desc: "百万级IP池，并且地区分布广泛，不限制IP切换数量，更划算，IP离散度高，重复率更低",
        },
        {
          icon: require("@/assets/images/cpjs6.png"),
          icon_active: require("@/assets/images/cpjs12.png"),
          desc: "支持访问HTTP/HTTPS协议的目标网站，原生支持，协议无需顾虑SSL证书问题",
        },
        {
          icon: require("@/assets/images/cpjs7.png"),
          icon_active: require("@/assets/images/cpjs13.png"),
          desc: "全部IP均为高匿，保证私密性，并且全部是家庭用IP，真人率更高",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.cpjs {
  padding: 50px 0 116px;
  .cpjs-desc {
    p {
      font-size: 18px;
      color: #000;
    }
  }
  .cpjs-imgs {
    margin-top: 75px;
  }
  .cpjs-list {
    margin-top: 74px;
    .title {
      font-size: 24px;
      color: #000;
      font-weight: bold;
      text-align: center;
    }
    .cpjs-list-content {
      .item {
        margin-top: 64px;
        width: 33.3%;
        text-align: center;
        img {
          &.img2 {
            display: none;
          }
        }
        p {
          width: 74%;
          margin: 24px auto 0;
          font-size: 18px;
          color: #474747;
          text-align: left;
        }
        &:hover {
          img {
            &.img1 {
              display: none;
            }
            &.img2 {
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .cpjs {
    padding: 4% 0;
  }
  .cpjs .cpjs-list .title {
    font-size: 16px;
  }
  .cpjs .cpjs-desc {
    margin-bottom: 2%;
  }
  .cpjs .cpjs-list .cpjs-list-content .item img {
    width: 50px;
  }
  .cpjs .cpjs-desc p,
  .cpjs .cpjs-list .cpjs-list-content .item p {
    font-size: 14px;
  }
  .cpjs .cpjs-list .cpjs-list-content .item p {
    margin: 2% auto;
  }
  .cpjs .cpjs-imgs,
  .cpjs .cpjs-list {
    margin-top: 2%;
  }
  .cpjs .cpjs-list .cpjs-list-content .item {
    width: 49%;
    margin-top: 2%;
  }
}
@media (max-width: 475px) {
  .cpjs .cpjs-list .cpjs-list-content .item {
    width: 100%;
  }
}
</style>
